<template>
  <header class="app-header navbar" v-if="$auth.ready()">
    <b-modal v-model="confirmLogoutModal"
      title=""
      class="modal-primary"
      @ok="logout">

      Tem certeza que deseja sair do painel administrativo?
    </b-modal>

    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>

    <b-link class="navbar-brand" :to="{ name: 'index' }"></b-link>

    <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
      <li class="item-in-nav-bar">
        <router-link :to="{ name: 'app.dashboard' }">
          <i class="icon-graph" v-b-tooltip.hover title="Dashboard" aria-hidden="true"></i>
        </router-link>

        <router-link :to="{ name: 'manageables.index', params: { entity: 'sys-users' } }" v-if="show">
          <i class="icon-user" v-b-tooltip.hover title="Usuários (Manager)" aria-hidden="true"></i>
        </router-link>

        <a :href="siteUrl" target="_blank">
          <i class="icon-home"
            v-b-tooltip.hover
            title="Ir para o site"
            aria-hidden="true"></i>
        </a>

        <router-link :to="{ name: 'app.settings' }" v-if="show">
          <i class="icon-settings" v-b-tooltip.hover title="Configurações" aria-hidden="true"></i>
        </router-link>
      </li>

      <!-- /** USER DROPDOWN WITH USER/AVATAR/PREFERENCES/LOGOUT */ -->
       <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <b class="user-data">
            {{loggedUser.name || 'Usuário'}}
            <i class="fa fa-chevron-down" aria-hidden="true"></i>
          </b>
        </template>

        <b-dropdown-item :to="{ name: 'app.profile' }">
          <i class="icon-user"></i>&nbsp;Perfil
        </b-dropdown-item>

        <b-dropdown-item :to="{ name: 'app.settings' }" v-if="show">
          <i class="icon-settings"></i>&nbsp;Configurações
        </b-dropdown-item>

        <b-dropdown-item @click.prevent="confirmLogoutModal = true">
          <i class="icon-logout"></i>&nbsp;Sair
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </ul>
  </header>
</template>

<script>
import config from '@/../config'
import { mapActions, mapGetters } from 'vuex'
import { isEmpty } from 'lodash'

export default {
  name: 'core-header',

  data () {
    return {
      confirmLogoutModal: false,

      search: '',

      siteUrl: config.local.SITE_URL.replace(/"/g, '')
    }
  },

  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      loggedUser: 'auth/user'
    }),

    show () {
      const self = this
      if (!isEmpty(self.loggedUser)) {
        const role = self.loggedUser.main_role.slug

        if (role === 'admin' || role === 'marketing') {
          return true
        }

        return false
      }
    }
  },

  methods: {
    ...mapActions({
      storeToken: 'auth/storeToken',
      revokeToken: 'auth/revokeToken',
      fetchUser: 'auth/fetchUser'
    }),

    logout () {
      const self = this

      self.confirmLogoutModal = false

      self.$auth.logout({
        success () {
          self.revokeToken()
        },
        error (e) {},
        redirect: { name: 'auth.login' }
      })
    },

    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  },

  created () {
    const self = this

    if (self.$auth.check() && !self.isAuthenticated) {
      self.storeToken([self.$auth])
      self.fetchUser()
    }
  }
}
</script>

<style lang="sass">
  .modal
    .modal-dialog
      transform: translate(-50%, -50%) !important
      top: 50%
      left: 50%
      margin: 0px

      .btn
        width: 50%

  .app-header.navbar .navbar-brand
    width: 200px
    transition: none

  .user-data a:hover
    text-decoration: none
    color: #fff !important
</style>



// WEBPACK FOOTER //
// src/components/core/Header.vue